import type { FC } from 'react';
import { Route } from 'react-router-dom';
import { useStorageServiceRoot } from 'src/apis/storage/use-storage-service-root';
import { ThrowNotFound } from 'src/components/feedback/not-found';
import { RootRoutes } from 'src/components/root-routes';
import { PageSpinner } from 'src/components/spinner-container';
import { StorageLocationDetails } from 'src/pages/storage/locations-new/details';
import { StorageLocationsOverviewNew } from 'src/pages/storage/locations-new/overview';

export const StorageLocationsNewRoot: FC = () => {
  const storageServiceRoot = useStorageServiceRoot();

  if (!storageServiceRoot.response) {
    return <PageSpinner />;
  }

  return (
    <RootRoutes>
      <Route
        path="/storage/locations-new"
        element={
          <StorageLocationsOverviewNew
            storageServiceRoot={storageServiceRoot}
          />
        }
      />
      <Route
        path="/storage/locations-new/:locationId"
        element={
          <StorageLocationDetails storageServiceRoot={storageServiceRoot} />
        }
      />

      <Route path="*" element={<ThrowNotFound />} />
    </RootRoutes>
  );
};
